import React from "react";
import { bool, node, string } from "prop-types";
import Line from "../../../Line";
import Paragraph from "../../../Paragraph";
import Image from "../../../Image";
import { Col, Container, Row } from "../../../Grid";
import Heading from "../../../Heading";
import { classes } from "../../../utils/classes";

export const FreeCourseLicenseContainer = ({ children }) => {
	return (
		<Container spacing={{ my: 10 }}>
			<Row utility={{ justify: "center" }}>
				<Col sm={12} md={10}>
					{children}
				</Col>
			</Row>
		</Container>
	);
};

FreeCourseLicenseContainer.propTypes = {
	children: node.isRequired,
};

export const FreeCourseLicenseHeader = ({ children }) => {
	return (
		<Heading Tag="h2" sx={{ fontSize: "xl", textAlign: "center" }}>
			{children}
		</Heading>
	);
};

FreeCourseLicenseHeader.propTypes = {
	children: node.isRequired,
};

export const FreeCourseLicenseSubtitle = ({ children }) => {
	return <Paragraph sx={{ fontSize: "l", textAlign: "center" }}>{children}</Paragraph>;
};

FreeCourseLicenseSubtitle.propTypes = {
	children: node.isRequired,
};

export const FreeCourseLicenseContentWrapper = ({ children }) => {
	return (
		<Container>
			<Row utility={{ justify: "center" }}>
				<Col sm={12} md={10} lg={9}>
					<Row>{children}</Row>
				</Col>
			</Row>
		</Container>
	);
};

FreeCourseLicenseContentWrapper.propTypes = {
	children: node.isRequired,
};

export const FreeCourseLicenseContentImage = ({ src }) => {
	return (
		<Col sm={12} md={6} sx={{ textAlign: "center" }}>
			<Image src={src} />
		</Col>
	);
};

FreeCourseLicenseContentImage.propTypes = {
	src: string.isRequired,
};

export const FreeCourseLicenseContentListWrapper = ({ children, isListPros = true }) => {
	return (
		<Col sm={12} md={6}>
			<ul className={classes("ul", isListPros ? "ul-check" : "ul-no-check", "text-m mt-4 mb-8")}>
				{children}
			</ul>
		</Col>
	);
};

FreeCourseLicenseContentListWrapper.propTypes = {
	children: node.isRequired,
	isListPros: bool,
};

export const FreeCourseLicenseContentListItem = ({ children }) => {
	return <li className="li ul__li text-m">{children}</li>;
};

FreeCourseLicenseContentListItem.propTypes = {
	children: string.isRequired,
};

export const FreeCourseLicenseFAQContainer = ({ children }) => {
	return (
		<Container spacing={{ mt: 10, mb: 40 }}>
			<Row utility={{ justify: "center" }}>
				<Col sm={12} md={9}>
					{children}
				</Col>
			</Row>
		</Container>
	);
};

FreeCourseLicenseFAQContainer.propTypes = {
	children: node.isRequired,
};

export const FreeCourseLicenseFAQItemWrapper = ({ children, line = true }) => {
	return (
		<Row spacing={{ mt: 6 }}>
			<Col sm={12}>
				{children}
				{line && <Line />}
			</Col>
		</Row>
	);
};

FreeCourseLicenseFAQItemWrapper.propTypes = {
	children: node.isRequired,
	line: bool,
};

export const FreeCourseLicenseFAQItemHeader = ({ children }) => {
	return (
		<Paragraph sx={{ fontSize: "l", fontWeight: "bold", fontColor: "1" }}>{children}</Paragraph>
	);
};

FreeCourseLicenseFAQItemHeader.propTypes = {
	children: node.isRequired,
};

export const FreeCourseLicenseFAQItemContent = ({ children }) => {
	return <Paragraph>{children}</Paragraph>;
};

FreeCourseLicenseFAQItemContent.propTypes = {
	children: node.isRequired,
};
